import React from 'react';
import styles from './_style.module.scss';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

// Dropdown of admin-authored choices; the value is a string token, the label is
// the localized description. The token submits under the option name.
const OptionSelect = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => value;

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  const choices = option.select_choices || [];

  if (!isVisible) {
    return <input type="hidden" name={option.name} value={value} />;
  }

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <label className={styles.label} data-widget-element="label">{option.presented_name}</label>
      <div className={styles.inputWrapper} data-widget-element="input-wrapper">
        <select
          name={option.name}
          value={value}
          onChange={onChange}
          className={`${styles.input} ${styles.inputWithoutSuffix}`}
          data-widget-element="select"
        >
          {choices.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {choice.description}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default OptionSelect;
